import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  createAccount as thunkCreateAccount,
  createDemo as thunkCreateDemo,
  fetchCountries as thunkCountries,
  fetchMediaList as thunkMediaList,
  fetchProductTypes as thunkProductTypes,
  fetchSalesChannels as thunkSalesChannelsList,
  fetchTld as thunkTld
} from "_config/store/onBoarding/onBoarding.thunk";
import { useToast } from "_hooks";
import { signUp } from "_config/store/account/account.thunk";

const useOnBoarding = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { toast } = useToast();

  const { data: countries, error: countriesError, isLoading: countriesIsLoading } = useSelector((s) => s.onBoarding.countries);
  const { data: account, error: accountError, isLoading: accountIsLoading } = useSelector((s) => s.onBoarding.createAccount);
  const { data: demo, error: demoError, isLoading: demoIsLoading } = useSelector((s) => s.onBoarding.createDemo);
  const { data: mediaList, error: mediaListError, isLoading: mediaListIsLoading } = useSelector((s) => s.onBoarding.mediaList)
  const { data: productTypes, error: productTypesError, isLoading: productTypesIsLoading } = useSelector((s) => s.onBoarding.productTypes);
  const { data: salesChannelsList, error: salesChannelsListError, isLoading: salesChannelsListIsLoading } = useSelector((s) => s.onBoarding.salesChannelsList);
  const { data: tld, error: tldError, isLoading: tldIsLoading } = useSelector((s) => s.account.tld);

  const createAccount = (_id) => dispatch(thunkCreateAccount({ _id}));

  const createDemo = (_id) => dispatch(thunkCreateDemo({ _id}));

  const fetchCountries = (params, extras = {}) => dispatch(thunkCountries(params, extras));
  
  const fetchMediaList = (params, extras = {}) => dispatch(thunkMediaList(params, extras));

  const fetchProductTypes = (params, extras = {}) => dispatch(thunkProductTypes(params, extras));

  const fetchSalesChannels = (params, extras = {}) => dispatch(thunkSalesChannelsList(params, extras));

  const fetchTld = (params, extras = {}) => dispatch(thunkTld(params, extras));

  const submitSignUp = async (data) => {
    let { email, privacy } = data;
    let { error } = await dispatch(signUp({
      fork: "core",
      email,
      flags: {
        priv: privacy
      }
    }));

    if (error) {
      switch (error?.status?.code) {
        case 105:
          navigate("/account/userWithAccount");
          break;
        case 103:
          navigate("/account/created");
          break;
        default:
          toast("Error", "error");
      };
    }
  }

  return {
    account,
    accountError,
    accountIsLoading,
    countries,
    countriesError,
    countriesIsLoading,
    createAccount,
    createDemo,
    demo,
    demoError,
    demoIsLoading,
    fetchCountries,
    fetchMediaList,
    fetchProductTypes,
    fetchSalesChannels,
    fetchTld,
    mediaList,
    mediaListError,
    mediaListIsLoading,
    productTypes,
    productTypesError,
    productTypesIsLoading,
    salesChannelsList,
    salesChannelsListError,
    salesChannelsListIsLoading,
    submitSignUp,
    tld,
    tldError,
    tldIsLoading
  };
};

export default useOnBoarding;
